import { useState, useEffect } from 'react';
import { getScreenSize, getResponsiveSpacing, getResponsiveFontSizes } from '../constants/utils';

function useResponsive() {
    const [screenSize, setScreenSize] = useState(getScreenSize());
    const [spacing, setSpacing] = useState(getResponsiveSpacing(screenSize));
    const [fonts, setFonts] = useState(getResponsiveFontSizes(screenSize));

    useEffect(() => {
        const handleResize = () => {
            const newScreenSize = getScreenSize();
            setScreenSize(newScreenSize);
            setSpacing(getResponsiveSpacing(newScreenSize));
            setFonts(getResponsiveFontSizes(newScreenSize));
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return { screenSize, spacing, fonts };
}

export default useResponsive;